// Production-aware logger.
// In production builds, log/info are silenced; warn/error still flow to DevTools
// so real issues surface in tools like Sentry/PostHog session recordings.
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
